import { Link } from 'react-router-dom';
import type { Movie } from '@/utils/movies';

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 hover:border-accent-400 transition-colors overflow-hidden cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-primary-700">
        <img
          src={movie.poster}
          alt={`${movie.title}（${movie.year}）电影海报`}
          title={`${movie.title} - ${movie.genres.join('、')} - 6080yy电影在线看`}
          className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-primary-950/85 to-transparent"></div>
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {typeof rank === 'number' && (
            <span className="w-6 h-6 rounded-md bg-accent-500 text-primary-950 text-xs font-heading font-bold flex items-center justify-center">
              {rank}
            </span>
          )}
          {movie.status !== '高清' && (
            <span className="px-2 py-0.5 rounded bg-primary-500/90 text-background-50 text-[11px] font-label">
              {movie.status}
            </span>
          )}
        </div>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded bg-accent-500 text-primary-950 text-xs font-heading font-bold">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between text-background-50/90 text-xs">
          <span className="font-label">{movie.year}</span>
          <span className="font-label truncate max-w-[60%] text-right">{movie.region}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-bold text-sm text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{movie.synopsis}</p>
        <div className="mt-2 flex flex-wrap gap-1">
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] font-label"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}